import React from 'react';
import { translate, TranslateOptionsParams } from '@fiverr-private/i18n-react';
import { Tooltip } from '@fiverr-private/tooltip';
import { Typography } from '@fiverr-private/typography';
import { QuestionMarkIcon } from '@fiverr-private/visuals';

export const TooltipInfo = ({ contentCopy, params }: { contentCopy: string; params?: TranslateOptionsParams }) => {
  const content = (
    <Typography color="grey_100" whiteSpace="preWrap" fontWeight="normal">
      {translate(`dm_brief_creation.sections.ideal_candidate.${contentCopy}`, params)}
    </Typography>
  );

  return (
    <Tooltip content={content} as="div" anchorProps={{ display: 'flex' }} position="bottom">
      <QuestionMarkIcon color="grey_700" size="xs" />
    </Tooltip>
  );
};
